

document.addEventListener("DOMContentLoaded", function () {
  setTimeout(function () {
    const products = document.querySelectorAll(".template-collection .boost-sd__product-list .boost-sd__product-item, .template-product .cstm-prdct-cls");

    products.forEach((product) => {
      const price = product.querySelector(".boost-sd__product-price--sale .boost-sd__format-currency, .price .current-price");
      const comparePrice = product.querySelector(".boost-sd__product-price--compare .boost-sd__format-currency, .price .was-price");

      if (comparePrice && comparePrice.textContent.trim() !== "") {
        product.classList.add("sale");
        product.classList.remove("no-sale");
      } else {
        product.classList.add("no-sale");
        product.classList.remove("sale");
      }
    });
  }, 8000);
});



document.addEventListener("DOMContentLoaded", function () {
  setTimeout(function () {
    const products = document.querySelectorAll(".boost-sd__product-item");

    products.forEach(function(product) {
      const title = product.querySelector(".boost-sd__product-title");
      if (title && title.textContent.toLowerCase().includes("ultra")) {
        product.classList.add("ultra");
      }
    });
  }, 5000);
});





document.addEventListener("DOMContentLoaded", function () {
    const currentUrl = window.location.href;

    const menuItems = {
        "https://coldest.com/collections/core-colors": ".cstm-hdr-mnu-sec .mnu-itm.core-collection",
        "https://coldest.com/collections/limitless-bottle-with-handle": ".cstm-hdr-mnu-sec .mnu-itm.drop-homcol",
        "https://coldest.com/collections/limitless-deals-and-steals": ".cstm-hdr-mnu-sec .mnu-itm.sale-collection",
        "https://coldest.com/pages/drop": ".cstm-hdr-mnu-sec .mnu-itm.drops-home",
        "https://coldest.com/pages/sale": ".cstm-hdr-mnu-sec .mnu-itm.sale-home"
    };

    const additionalPages = [
        "https://coldest.com/collections/for-her",
        "https://coldest.com/collections/for-him"
    ];

  
    Object.keys(menuItems).forEach(url => {
        if (currentUrl.includes(url)) {
            const menuItem = document.querySelector(menuItems[url]);
            if (menuItem) {
                menuItem.classList.add("mnu-actv");
            }
        }
    });

    

    additionalPages.forEach(url => {
        if (currentUrl.includes(url)) {
            const hdrMnu = document.querySelector(".cstm-hdr-mnu-sec");
            if (hdrMnu) hdrMnu.style.display = "block";
        }
    });

});









window.addEventListener("load", (event) => {

  /* Product-card labels by variant id. Every lookup is null-guarded: these
     variant ids rotate with drops, and one missing card must not throw and
     kill the rest of the labels (or any listener below). */
  const cardLabels = {
    "46924712575208": ["Just Dropped", "JD"],   // Blackhawk Camo
    "46875870494952": ["Low Inventory", "LI"],  // Rocketship Alloy
    "46879904661736": ["Low Inventory", "LI"],  // Blue Nova
    "46875865940200": ["Just Dropped", "JD"],   // Crowned Luna
    "46879904596200": ["Low Inventory", "LI"],  // Red Nova
    "46924713361640": ["Just Dropped", "JD"],   // Moonlight Hearts
    "46924713623784": ["Just Dropped", "JD"],   // The Republican
    "46924713558248": ["Just Dropped", "JD"],   // The Democrat
    "46924713033960": ["Just Dropped", "JD"],   // The Cardinal
    "46924713165032": ["Just Dropped", "JD"]    // Avocado Reflections
  };

  Object.keys(cardLabels).forEach(function (variantId) {
    const label = document.querySelector('.product-list .product-block[data-variant-id="' + variantId + '"] .samita_productLabel-content[data-id="52332"]');
    if (!label) return;
    const span = label.querySelector("span");
    if (span) span.innerText = cardLabels[variantId][0];
    label.id = cardLabels[variantId][1];
  });

});


document.addEventListener("DOMContentLoaded", function () {


  /* Login page only — null-guarded so this listener survives on every other
     page (an unguarded appendChild here used to throw sitewide and kill the
     Red Dress GPO check registered below). */
  const lgnfrm = document.querySelector(".template-customers-login .small-form .opposing-items");
  if (lgnfrm) {
    const crtacc = document.createElement('span');
    crtacc.innerText = `Don't have an account?`;
    lgnfrm.appendChild(crtacc);
  }



  
    setTimeout(() => {

const currentUrl = window.location.href;
    const targetUrl = "https://coldest.com/products/coldest-limitless-bottle?variant=46875866136808";

    if (currentUrl === targetUrl) {
        const productOption1 = document.querySelector(".gpo-container");
        if (productOption1) {
            productOption1.classList.add("active");
        }
    }


      
    }, 5000);
});





